var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "router-link",
    {
      attrs: {
        to: _vm.props.href,
        "active-class": _vm.props.activeClass,
        "exact-active-class": _vm.props.exactActiveClass,
        exact: _vm.props.href == "/"
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9be8ea8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9be8ea8","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/LinkElements/RouterLink.vue
// module id = 271
// module chunks = 17